module.exports = __webpack_public_path__ + "static/media/Lahore High court c. 1940s.5eeac20e.jpg";